import { buildMultilineAction, getIndentationAndContent } from '../utils'
import { bulletRe, orderedRe } from '../listUtils'

type UnorderedCtx = {
  allBullets: boolean
}

const buildUnorderedTransformer = (ctx: UnorderedCtx) => (ln: string) => {
  const bulletWithSpace = '- '

  if (ctx.allBullets) {
    const m = ln.match(bulletRe)!
    const indent = m[1] || ''
    const content = ln.slice(m[0].length)
    return indent + content
  }

  if (bulletRe.test(ln)) {
    return ln
  }

  const mo = ln.match(orderedRe)
  const [indent, content] = mo
    ? [mo[1] || '', ln.slice(mo[0].length)]
    : getIndentationAndContent(ln)

  return indent + bulletWithSpace + content
}

export const toggleUnorderedListAction = buildMultilineAction(
  (info) => ({ allBullets: info.lines.every((ln) => bulletRe.test(ln)) }),
  buildUnorderedTransformer,
)
